import ApiCore from '@/api/api-core'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class ReportsStatistical extends ApiCore {
  constructor(store) {
    super(store, `${ ACTIVE_BASE_REST }/statistical`)
  }

  orderStatistical(filter, showProgress) {
    return this._request({
      action: 'order',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  courierOrderStatistical(filter, showProgress) {
    return this._request({
      action: 'courierOrder',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  courierScoreStatistical(filter, showProgress) {
    return this._request({
      action: 'courierScore',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  userStatistical(filter, showProgress) {
    return this._request({
      action: 'user',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
